// src/supabaseClient.ts
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://ufqlvqoaghopavqggahm.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVmcWx2cW9hZ2hvcGF2cWdnYWhtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTAyMDUzMTAsImV4cCI6MjA2NTc4MTMxMH0.olBx_gbh0Dp9zLomtgydQyKmcf6FWnfhe2d_w2r6Isw';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);